<template>
    <div>
        <header class="form-title">
            <Row>
                <Col span="22">
                    <Form inline :label-width="100">
                        <FormItem label="商品名/货号">
                            <Input v-model="shop.goodsname" />
                        </FormItem>
                        <FormItem label="选择门店">
                            <Select v-model="shop.name" filterable style="width: 150px">
                                <Option
                                        v-if="k.isgeneralwarehouse!='Y'&&shopingId!=k.id"
                                        :value="k.id"
                                        v-for="(k,v) in shopList"
                                        :key="v">{{k.name}}
                                </Option>
                            </Select>
                            <Button type="primary" style="margin-left: 15px"   @click="searchCondition">搜索</Button>
                            <Button type="warning" style="margin-left: 15px" :loading="buttonLoading" @click="capyCondition">
                                <span v-if="!buttonLoading">复制</span>
                                <span v-else>复制中</span>
                            </Button>
                        </FormItem>
                    </Form>
                </Col>

            </Row>
        </header>
        <Table stripe :columns="columns" :data="data" :loading="loadingTable" class="tableList"    @on-selection-change="selectionChange">
            <template slot-scope="{ row, index }" slot="first">
                <div class="imgbox" style="margin: 10px">
                    <Fy-Img
                            class="img"
                            :ImgSrc="row.goodsimg | filtImg(row.goodsimg)"
                            :Width="50"
                            :Height="50">
                    </Fy-Img>
                    <span v-if="row.tagCode!=null">总</span>
                </div>
            </template>
        </Table>
        <div class="pageTotal">
            <Page show-sizer :total="page.total"
                  show-elevator
                  :page-size-opts = [10,20,50,100]
                  show-total
                  :page-size="page.rows"
                  @on-change="onGongPageTotal"
                  @on-page-size-change = "onPageSizeChange"/>
        </div>
    </div>
</template>
<script>
    import FyImg from "../../components/Common/FyImg";
    export default {
        components: {FyImg},

        data() {
            return {
                cid: '',
                sid: '',
                shopingId:JSON.parse(localStorage.getItem('shop')).id,//当前店铺id
                shopList:[],
                shop:{
                    name:'',
                    goodsname:''
                },
                data: [],
                columns: [
                    { type: 'selection', width: 60},
                    {title: '商品图', key: 'goodsimg', align: 'center', slot:"first"},
                    {title: '商品名称', key: 'name', align: 'center'},
                    {title: '货号', key: 'goodscode', align: 'center'},
                    {title: '库存', key: 'num', align: 'center'},
                    {title: '零售价', key: 'lprice', align: 'center'},
                    {title: '批发价', key: 'pprice', align: 'center'},
                    {title: '采购价', key: 'cprice', align: 'center'},
                ],
                loadingTable:true,
                buttonLoading:false,
                page:{
                    total:0,
                    page:1,
                    rows:10
                },
                goodsIds:[],//选择的id集合

            };
        },
        created: function () {
            this.cid = JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id

            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code
            if(!PermisCode.includes('94')){
                 this.columns.pop()
                console.log( this.columns)
            }


            this.getShopList()
            this.getGoodsList()
        },
        watch: {
            'shop.goodsname': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.getGoodsList()
                }
            },
        },
        methods: {
            //店铺列表
            getShopList() {
                var data = {
                    cid: this.cid,
                    page: 1,
                    rows: 1000
                };
                this.$Api.getShopList(data).then(res => {
                    this.shopList = res.data;
                });
            },
            //获取所有商品列表
            getGoodsList(){
                this.loadingTable=true
                this.$Api.getListByGoodsnameOrGoodscode({
                    cid: this.cid,
                    sid: this.sid,
                    page: this.page.page,
                    rows:this.page.rows,
                    condition:this.shop.goodsname,
                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                        this.data = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.loadingTable=false
                }).catch((item)=>{
                    this.$Message.warning(item.msg);
                    this.loadingTable=false
                });
            },
            //复制
            selectionChange(data){
                this.goodsIds = data

            },
            //复制
            capyCondition(){

                var strs=''
                if(this.goodsIds.length==0){
                    this.$Message.warning("你还没有选择商品呢！");
                    return
                }
                if(this.shop.name==''){
                    this.$Message.warning("请选择要复制到的门店");
                    return
                }
                this.goodsIds.forEach(item=>{
                    strs += item.id+','
                })
                strs = strs.slice(0,strs.length-1)
                this.buttonLoading=true
                this.$Api.copyGoodsToZc({
                    cid: this.cid,
                    sid: this.shop.name,
                    goodsIds: strs,
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success(res.msg);
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    this.buttonLoading=false
                }).catch((item)=>{
                    this.buttonLoading=false
                    this.$Message.warning(item.msg);
                });
            },
            //修改分页
            onGongPageTotal(num){
                this.page.page=num
                this.getGoodsList()
            },
            onPageSizeChange(rows){
                this.page.rows = rows
                this.getGoodsList()
            },

            searchCondition(){
                this.getGoodsList()
            },

        },

    };
</script>

<style lang="scss" scoped>
    .form-title {
        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }

    .tableList .ivu-table-row td{
        padding: 10px 0;
        .img{
            display: block;
            margin:10px auto;
        }
    }

</style>